import React from 'react';
import moment from 'moment';
import { NavLink } from "react-router-dom";
import DataTable from 'react-data-table-component';
import { Alert }  from 'reactstrap';
import { TableSearchForm } from '../Common/TableSearchForm';
import { TenantActionsButton } from './ActionsButton';

export function TenantsList(props) {

    const columns = [
        {
            name: 'Name',
            selector: 'name',
            sortable: true,
            ignoreRowClick: true,
            cell: (row) => {
                return <NavLink to={'/organisations/edit/' + row.id}>{row.name}</NavLink>
            }
        },
        {
            name: 'Identifier',
            selector: 'identifier',
            sortable: true
        },
        {
            name: 'Shortcode',
            selector: 'shortcode',
            sortable: true
        },
        {
            name: 'Owner',
            selector: 'ownerId',
            sortable: true,
            cell: (row) => {
                if (row.owner != null) {
                    return <span>{row.owner.firstName} {row.owner.surname}</span>
                }                
            }
        },
        {
            name: 'Date Raised',
            selector: 'dateCreated',
            sortable: true,
            cell: (row) => {
                return moment(row.dateCreated).format('DD/MM/YYYY')
            }            
        },
        {
            name: '',
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            cell: (row) => {
                return (
                    <TenantActionsButton 
                        tenant={row} 
                        handleEdit={props.handleEdit} 
                        handleDelete={props.handleDelete}
                    />
                );
            }
        }
    ];

    const hasAny = props.items && props.items.length > 0;

    return (
        <>
            <TableSearchForm handleSearch={props.handleSearch} />
            {
                hasAny ? (
                    <DataTable
                        columns={columns}
                        data={props.items}
                        defaultSortField="name"
                        pagination
                        highlightOnHover
                        noHeader
                        paginationPerPage={50}
                        paginationRowsPerPageOptions={[10, 25, 50, 100]}
                    />
                ) : <Alert color="warning">No Organisations were found</Alert>
            }
        </>
    );
}

